import defaultCategoryOptions from '../config/categoryOptions.json';

const singularCategoryNames = {
  'amazing-views': 'Amazing View',
  rooms: 'Room',
  mansions: 'Mansion',
  cabins: 'Cabin',
  'small-homes': 'Small Home',
  castles: 'Castle',
  'famous-cities': 'City',
  campers: 'Camper',
};

export const categoryNameForSEO = (option, fallbackLabel = '') =>
  singularCategoryNames[option] || fallbackLabel || option || '';

export const categoryOptionsFromConfig = config =>
  config?.listing?.categoryOptions ||
  config?.listing?.listingFields?.find(field => field.key === 'category')?.enumOptions ||
  defaultCategoryOptions;
